// extracted by mini-css-extract-plugin
module.exports = {"colors":"'assets/css/colors.module.css'","textColor":"#182C3D","enroll-button":"buttons_enroll-button__15kXN","enroll":"buttons_enroll__1L_dH"};